import { defineMessages } from 'react-intl'

export const getMessages = () =>
  defineMessages({
    instructorsWarning: {
      id: 'For best results, we recommend scheduling 3 classes per week',
      defaultMessage: 'For best results, we recommend scheduling 3 classes per week',
    },
    Instructors: {
      id: 'Instructors',
      defaultMessage: 'Instructors',
    },
    Favourite: {
      id: 'Favorite',
      defaultMessage: 'Favorite',
    },
    Past: {
      id: 'Past',
      defaultMessage: 'Past',
    },
    MostAvailable: {
      id: 'Most available',
      defaultMessage: 'Most available',
    },
  })
